function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.052 12.046c0 1.05.851 1.902 1.902 1.902h8.092c1.05 0 1.902-.851 1.902-1.902v-.809a.526.526 0 011.052 0v.81A2.954 2.954 0 0112.046 15H3.954A2.954 2.954 0 011 12.046v-.809a.526.526 0 011.052 0v.81zm2.34-4.418a.526.526 0 01.743 0l2.339 2.34V1.525a.526.526 0 111.052 0v8.441l2.339-2.339a.526.526 0 01.744.744l-3.237 3.237a.526.526 0 01-.744 0L4.391 8.372a.526.526 0 010-.744z",
  fill: "#2D2D2D"
});
function SvgDescarga(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Descarga.svg";
export { SvgDescarga as ReactComponent };